import { ventilacionHeroImage } from "@/mocks/serviceVentilacionData";

export default function VentilacionHero() {
  return (
    <section className="relative min-h-[460px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={ventilacionHeroImage}
          alt="Sistema de ventilación mecánica profesional con ductos HVAC y equipos de extracción"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay-gradient absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/25" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-5xl mx-auto">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 [text-shadow:0_2px_18px_rgba(0,0,0,0.85)]">
            VENTILACIÓN MECÁNICA
          </h1>

          <p className="text-base md:text-lg text-white font-semibold mb-4 leading-relaxed [text-shadow:0_1px_10px_rgba(0,0,0,0.8)]">
            Soluciones eficientes para renovación, extracción y circulación de aire
          </p>

          <p className="text-white/95 text-sm md:text-base max-w-2xl leading-relaxed mb-8 [text-shadow:0_1px_8px_rgba(0,0,0,0.75)]">
            En <strong className="text-white">SERIN Ingeniería de Proyectos</strong> diseñamos e
            implementamos sistemas de ventilación mecánica adaptados a las necesidades de cada espacio,
            garantizando una adecuada renovación y extracción del aire para crear ambientes más seguros,
            saludables y confortables.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#cotizacion"
              className="px-7 py-3.5 rounded-lg bg-[#0087a4] text-white font-semibold text-sm md:text-base hover:bg-[#006f86] transition-colors shadow-lg shadow-[#0087a4]/20 text-center whitespace-nowrap"
            >
              <i className="ri-file-list-3-line mr-2" />
              SOLICITAR COTIZACIÓN
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}